{
	"title": "Notifications",
	"read": "Tous",
	"unread": "Non lus",
	"emptyNotifications": "Vous avez atteint la fin de la liste !",
	"emptyUnreadNotifications": "Vous êtes à jour de toutes les nouvelles !",
	"noNews": "Pas de nouvelles !",
	"levelTag": "Niveau {{tag}}",
	"classification": {
		"alert": "Instabilité",
		"release": "Lancement",
		"warning": "Amélioration"
	},
	"level": {
		"app": "Application utilisateur",
		"organization": "Organisation",
		"place": "Lieu",
		"event": "Événement",
		"pdv": "Pdv"
	},
	"onboarding": {
		"modularization": {
			"title": "Présentation du <strong>Nouveau Menu Zig</strong>",
			"content": "<strong>Maintenant, vous pouvez...</strong> visualiser votre historique financier de manière détaillée et personnalisée, avec des filtres avancés et des rapports qui facilitent le suivi de vos transactions.",
			"primaryActionLabel": "En savoir plus",
			"secondaryActionLabel": "Passer"
		},
		"bonusReport": {
			"title": "Suivez les bonus attribués et utilisés",
			"content": "Vous pouvez maintenant suivre les bonus attribués et utilisés à partir de rapports détaillés avec le total distribué, le nom du client, de l'employé, le motif et le montant. Consultez le nouveau rapport en accédant à l'onglet Bonus dans les rapports financiers de votre établissement.",
			"primaryActionLabel": "Fermer"
		},
		"salesReport": {
			"title": "Il s'appelle maintenant Rapports de Ventes!",
			"content": "L'ancien Rapport de Bar existe toujours, mais il s'appelle maintenant Rapports de Ventes. Pour y accéder, allez dans le menu de l'établissement et cliquez sur l'onglet 'Rapports de Ventes'.",
			"primaryActionLabel": "Fermer"
		}
	},
	"goToInvoices": "Aller aux factures",
	"xmlZipError": "Téléchargement avec erreur",
	"xmlZipSuccess": "Téléchargement terminé",
	"downloadInvoicesTitle": "Téléchargement de factures",
	"downloadStarted": "Téléchargement démarré",
	"downloadMessage": "Le fichier zip sera disponible dans vos notifications bientôt.",
	"backToInvoices": "Retour aux factures"
}
